module.exports = __webpack_public_path__ + "img/clientVV.4ca23af1.png";